import { CustomerModules, OrderSideNavProps } from '@helpers/Constants';
import { Assets } from '@helpers/Constants/Assets';
import { FrontendRoutes } from '@helpers/Constants/Navigation';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

//Side Nav Top icons
const OrderSidenavItems = [
  {
    id: 1,
    moduleId: 1,
    label: 'Dashboard',
    path: FrontendRoutes.DASHBOARD,
    icon: (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.302734 17.6966V16.1256L1.70173 14.7266V17.6966H0.302734ZM4.30273 17.6966V12.1256L5.70173 10.7266V17.6966H4.30273ZM8.30273 17.6966V10.7266L9.70173 12.1506V17.6966H8.30273ZM12.3027 17.6966V12.1506L13.7017 10.7516V17.6966H12.3027ZM16.3027 17.6966V8.12556L17.7017 6.72656V17.6966H16.3027ZM0.302734 12.0976V10.1256L6.99973 3.42356L10.9997 7.42356L17.7017 0.726562V2.69856L10.9997 9.39581L6.99973 5.39581L0.302734 12.0976Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  {
    id: 2,
    label: 'Customer List',
    moduleId: 3,
    path: FrontendRoutes.CUSTOMER_LIST,
    icon: (
      <svg
        width="16"
        height="20"
        viewBox="0 0 16 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.0035 11.5991C8.46016 11.5991 8.84858 11.4378 9.16875 11.1153C9.48891 10.7928 9.649 10.4032 9.649 9.94656C9.649 9.4899 9.48858 9.10148 9.16775 8.78131C8.84691 8.46115 8.45733 8.30106 7.999 8.30106C7.54383 8.30106 7.15541 8.46148 6.83375 8.78231C6.51191 9.10315 6.351 9.49273 6.351 9.95106C6.351 10.4062 6.51225 10.7946 6.83475 11.1163C7.15725 11.4381 7.54683 11.5991 8.0035 11.5991ZM4.351 15.1903H11.649V14.9278C11.649 14.5923 11.5593 14.2948 11.38 14.0353C11.2007 13.776 10.9535 13.5761 10.6385 13.4356C10.2288 13.2659 9.80533 13.1329 9.368 13.0366C8.9305 12.9404 8.47425 12.8923 7.99925 12.8923C7.52408 12.8923 7.068 12.9404 6.631 13.0366C6.194 13.1329 5.77083 13.2659 5.3615 13.4356C5.0465 13.5761 4.79933 13.776 4.62 14.0353C4.44066 14.2948 4.351 14.5923 4.351 14.9278V15.1903ZM13.6135 19.2288H2.3865C1.91383 19.2288 1.51158 19.0629 1.17975 18.7311C0.847747 18.3991 0.681747 17.9968 0.681747 17.5243V2.33731C0.681747 1.86481 0.847747 1.46256 1.17975 1.13056C1.51158 0.798728 1.91416 0.632812 2.3875 0.632812H9.7295L15.3182 6.22306V17.5238C15.3182 17.9966 15.1522 18.3991 14.8202 18.7311C14.4884 19.0629 14.0862 19.2288 13.6135 19.2288ZM13.6115 17.8298C13.6885 17.8298 13.759 17.7978 13.823 17.7338C13.8872 17.6696 13.9192 17.5991 13.9192 17.5221V6.82056L9.1345 2.03181H2.3885C2.3115 2.03181 2.241 2.06381 2.177 2.12781C2.11283 2.19198 2.08075 2.26256 2.08075 2.33956V17.5221C2.08075 17.5991 2.11283 17.6696 2.177 17.7338C2.241 17.7978 2.3115 17.8298 2.3885 17.8298H13.6115Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  {
    id: 3,
    label: 'All Orders',
    moduleId: 5,
    path: FrontendRoutes.ALL_ORDER_LIST,
    icon: (
      <svg
        width="18"
        height="16"
        viewBox="0 0 18 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.22689 14.5936V13.1946H17.3181V14.5936H6.22689ZM6.22689 8.68688V7.28788H17.3181V8.68688H6.22689ZM6.22689 2.79538V1.39638H17.3181V2.79538H6.22689ZM2.26164 15.4791C1.82781 15.4791 1.45597 15.3234 1.14614 15.0119C0.836474 14.7004 0.681641 14.3277 0.681641 13.8939C0.681641 13.4599 0.837391 13.088 1.14889 12.7784C1.46039 12.4685 1.83306 12.3136 2.26689 12.3136C2.70089 12.3136 3.07272 12.4694 3.38239 12.7809C3.69206 13.0924 3.84689 13.4651 3.84689 13.8991C3.84689 14.333 3.69114 14.7047 3.37964 15.0144C3.06814 15.3242 2.69547 15.4791 2.26164 15.4791ZM2.26164 9.56763C1.82781 9.56763 1.45597 9.41263 1.14614 9.10263C0.836474 8.79246 0.681641 8.41971 0.681641 7.98438C0.681641 7.54904 0.837391 7.17654 1.14889 6.86688C1.46039 6.55704 1.83306 6.40213 2.26689 6.40213C2.70089 6.40213 3.07272 6.55788 3.38239 6.86938C3.69206 7.18088 3.84689 7.55429 3.84689 7.98963C3.84689 8.42513 3.69114 8.79696 3.37964 9.10513C3.06814 9.41346 2.69547 9.56763 2.26164 9.56763ZM2.26164 3.68112C1.82781 3.68112 1.45597 3.52537 1.14614 3.21387C0.836474 2.90237 0.681641 2.52963 0.681641 2.09563C0.681641 1.66179 0.837391 1.29004 1.14889 0.980376C1.46039 0.670542 1.83306 0.515625 2.26689 0.515625C2.70089 0.515625 3.07272 0.671375 3.38239 0.982875C3.69206 1.29438 3.84689 1.66704 3.84689 2.10088C3.84689 2.53488 3.69114 2.90671 3.37964 3.21638C3.06814 3.52621 2.69547 3.68112 2.26164 3.68112Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  {
    id: 4,
    label: 'Service Processing',
    moduleId: 6,
    path: FrontendRoutes.SERVICE_PROCESSING_LIST,
    icon: (
      <svg
        width="20"
        height="16"
        viewBox="0 0 20 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.702026 15.2288V5.86831C0.702026 5.39431 0.867943 4.9914 1.19978 4.65956C1.53178 4.32756 1.93453 4.16156 2.40803 4.16156H5.30303V2.33831C5.30303 1.86415 5.46811 1.46131 5.79828 1.12981C6.12844 0.798479 6.53219 0.632812 7.00953 0.632812H12.9953C13.4691 0.632812 13.872 0.798728 14.204 1.13056C14.536 1.46256 14.702 1.86556 14.702 2.33956V4.16156H17.593C18.0659 4.16156 18.4683 4.32756 18.8003 4.65956C19.1321 4.9914 19.298 5.39431 19.298 5.86831V15.2288H0.702026ZM5.59128 10.3923V11.4933H4.19228V10.3923H2.10103V13.8298H17.899V10.3923H15.8078V11.4933H14.4088V10.3923H5.59128ZM2.10103 5.86831V8.99331H4.19228V7.89231H5.59128V8.99331H14.4088V7.89231H15.8078V8.99331H17.899V5.86831C17.899 5.79131 17.867 5.72081 17.803 5.65681C17.7389 5.59265 17.6683 5.56056 17.5913 5.56056H2.40878C2.33178 5.56056 2.26119 5.59265 2.19703 5.65681C2.13303 5.72081 2.10103 5.79131 2.10103 5.86831ZM6.70203 4.16156H13.303V2.33956C13.303 2.26256 13.2709 2.19198 13.2068 2.12781C13.1426 2.06381 13.0721 2.03181 12.9953 2.03181H7.00953C6.92953 2.03181 6.85828 2.06381 6.79578 2.12781C6.73328 2.19198 6.70203 2.26256 6.70203 2.33956V4.16156Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  {
    id: 5,
    label: 'Product Processing',
    moduleId: 7,
    path: FrontendRoutes.PRODUCT_PROCESSING_LIST,
    icon: (
      <svg
        width="20"
        height="18"
        viewBox="0 0 20 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.5984 7.93012V15.8186C18.5984 16.2926 18.4325 16.6955 18.1007 17.0274C17.7687 17.3594 17.3657 17.5254 16.8917 17.5254H3.10817C2.63417 17.5254 2.23125 17.3594 1.89942 17.0274C1.56742 16.6955 1.40142 16.2926 1.40142 15.8186V7.91087C0.980254 7.60704 0.673338 7.18563 0.480671 6.64663C0.288171 6.10746 0.288671 5.53687 0.482171 4.93487L1.47317 1.68937C1.60534 1.28121 1.8295 0.952291 2.14567 0.702625C2.46184 0.452958 2.83959 0.328125 3.27892 0.328125H16.7039C17.1403 0.328125 17.5161 0.446624 17.8314 0.683624C18.1466 0.920458 18.3738 1.24938 18.5129 1.67038L19.5177 4.93487C19.7113 5.53821 19.7118 6.10846 19.5192 6.64562C19.3265 7.18279 19.0196 7.61096 18.5984 7.93012ZM12.1684 7.24737C12.7289 7.24737 13.1453 7.08046 13.4177 6.74662C13.6902 6.41262 13.8014 6.05396 13.7514 5.67062L13.1514 1.72712H10.6994V5.65712C10.6994 6.08462 10.8436 6.45654 11.1319 6.77287C11.4203 7.08921 11.7658 7.24737 12.1684 7.24737ZM7.72917 7.24737C8.19401 7.24737 8.57209 7.08921 8.86342 6.77287C9.15475 6.45654 9.30042 6.08462 9.30042 5.65712V1.72712H6.84842L6.25342 5.70913C6.20459 6.05579 6.31734 6.39887 6.59167 6.73837C6.86617 7.07771 7.24534 7.24737 7.72917 7.24737ZM3.34092 7.24737C3.72159 7.24737 4.04609 7.11587 4.31442 6.85287C4.58275 6.58987 4.74825 6.26079 4.81092 5.86562L5.41192 1.72712H3.22842C3.11942 1.72712 3.032 1.75121 2.96617 1.79937C2.9005 1.84737 2.85325 1.91946 2.82442 2.01562L1.85042 5.24937C1.70492 5.72437 1.76842 6.17613 2.04092 6.60463C2.31325 7.03312 2.74659 7.24737 3.34092 7.24737ZM16.6592 7.24737C17.2002 7.24737 17.6243 7.04296 17.9317 6.63412C18.239 6.22512 18.3116 5.76354 18.1494 5.24937L17.1504 1.99637C17.1184 1.90021 17.0696 1.83129 17.0039 1.78962C16.9381 1.74796 16.8523 1.72712 16.7467 1.72712H14.5927L15.1879 5.86562C15.2514 6.25679 15.4173 6.58488 15.6854 6.84987C15.9538 7.11487 16.2783 7.24737 16.6592 7.24737ZM3.10817 16.1264H16.8917C16.9815 16.1264 17.0553 16.0975 17.1129 16.0399C17.1706 15.982 17.1994 15.9083 17.1994 15.8186V8.56562C17.0956 8.60029 17.0013 8.62246 16.9164 8.63212C16.8314 8.64162 16.7456 8.64637 16.6589 8.64637C16.2141 8.64637 15.8228 8.56496 15.4852 8.40212C15.1473 8.23946 14.8243 7.97862 14.5159 7.61962C14.2459 7.93246 13.9206 8.18179 13.5399 8.36763C13.1593 8.55346 12.7249 8.64637 12.2369 8.64637C11.8171 8.64637 11.424 8.55829 11.0577 8.38212C10.6913 8.20579 10.3422 7.95162 10.0102 7.61962C9.70117 7.95162 9.35117 8.20579 8.96017 8.38212C8.56901 8.55829 8.17917 8.64637 7.79067 8.64637C7.35367 8.64637 6.93767 8.56804 6.54267 8.41138C6.14784 8.25471 5.80042 7.99079 5.50042 7.61962C5.06959 8.05029 4.68084 8.32912 4.33417 8.45612C3.98734 8.58296 3.65634 8.64637 3.34117 8.64637C3.25317 8.64637 3.16317 8.64162 3.07117 8.63212C2.97917 8.62246 2.88892 8.60029 2.80042 8.56562V15.8186C2.80042 15.9083 2.82925 15.982 2.88692 16.0399C2.94459 16.0975 3.01834 16.1264 3.10817 16.1264Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  {
    id: 6,
    label: 'Invoice',
    moduleId: 8,
    path: FrontendRoutes.INVOICE_LIST,
    icon: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.29225 16.7374H10.6578V15.5259C11.4334 15.4208 12.1357 15.1294 12.7645 14.6517C13.3933 14.1742 13.7078 13.4502 13.7078 12.4797C13.7078 11.7797 13.5013 11.1604 13.0885 10.6219C12.6757 10.0836 11.8693 9.59777 10.6692 9.16444C9.61792 8.80544 8.91983 8.49452 8.575 8.23169C8.23017 7.96885 8.05775 7.60152 8.05775 7.12969C8.05775 6.65785 8.23433 6.27452 8.5875 5.97969C8.94067 5.68485 9.42817 5.53744 10.05 5.53744C10.5705 5.53744 10.9903 5.66019 11.3095 5.90569C11.6288 6.15119 11.8744 6.45919 12.0462 6.82969L13.2807 6.33344C13.0717 5.80144 12.7311 5.34602 12.2587 4.96719C11.7862 4.58835 11.2692 4.3771 10.7078 4.33344V3.12194H9.34225V4.33344C8.48975 4.4976 7.835 4.84344 7.378 5.37094C6.92083 5.8986 6.69225 6.48485 6.69225 7.12969C6.69225 7.88102 6.91983 8.48552 7.375 8.94319C7.83017 9.40085 8.57183 9.81427 9.6 10.1834C10.6628 10.5733 11.3888 10.923 11.778 11.2327C12.167 11.5422 12.3615 11.9579 12.3615 12.4797C12.3615 13.1067 12.1353 13.5621 11.6827 13.8459C11.2301 14.1299 10.7192 14.2719 10.15 14.2719C9.58717 14.2719 9.08367 14.1028 8.6395 13.7644C8.19517 13.4259 7.85375 12.931 7.61525 12.2797L6.35 12.7952C6.609 13.5374 6.98108 14.127 7.46625 14.5642C7.95158 15.0014 8.56025 15.3053 9.29225 15.4759V16.7374ZM10 19.4297C8.68717 19.4297 7.45292 19.18 6.29725 18.6807C5.14142 18.1814 4.13592 17.5041 3.28075 16.6489C2.42558 15.7938 1.74833 14.7883 1.249 13.6324C0.749667 12.4768 0.5 11.2425 0.5 9.92969C0.5 8.61685 0.749667 7.3826 1.249 6.22694C1.74833 5.0711 2.42558 4.0656 3.28075 3.21044C4.13592 2.35527 5.14142 1.67802 6.29725 1.17869C7.45292 0.679355 8.68717 0.429688 10 0.429688C11.3128 0.429688 12.5471 0.679355 13.7028 1.17869C14.8586 1.67802 15.8641 2.35527 16.7193 3.21044C17.5744 4.0656 18.2517 5.0711 18.751 6.22694C19.2503 7.3826 19.5 8.61685 19.5 9.92969C19.5 11.2425 19.2503 12.4768 18.751 13.6324C18.2517 14.7883 17.5744 15.7938 16.7193 16.6489C15.8641 17.5041 14.8586 18.1814 13.7028 18.6807C12.5471 19.18 11.3128 19.4297 10 19.4297ZM10 17.9297C12.2333 17.9297 14.125 17.1547 15.675 15.6047C17.225 14.0547 18 12.163 18 9.92969C18 7.69635 17.225 5.80469 15.675 4.25469C14.125 2.70469 12.2333 1.92969 10 1.92969C7.76667 1.92969 5.875 2.70469 4.325 4.25469C2.775 5.80469 2 7.69635 2 9.92969C2 12.163 2.775 14.0547 4.325 15.6047C5.875 17.1547 7.76667 17.9297 10 17.9297Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  {
    id: 7,
    label: 'Pick Up',
    moduleId: 9,
    path: FrontendRoutes.ORDER_PICKUP_LIST,
    icon: (
      <svg
        width="22"
        height="16"
        viewBox="0 0 22 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.563 15.3881C3.81233 15.3881 3.16867 15.1193 2.632 14.5818C2.09517 14.0443 1.82675 13.3951 1.82675 12.6343H0.41925V1.87906C0.41925 1.50173 0.557834 1.17365 0.835001 0.894812C1.11217 0.615979 1.4415 0.476562 1.823 0.476562H15.719V4.38031H18.0558L21.5808 9.08806V12.6343H19.9633C19.9633 13.3951 19.692 14.0443 19.1495 14.5818C18.607 15.1193 17.9577 15.3881 17.2015 15.3881C16.4482 15.3881 15.8038 15.1193 15.2683 14.5818C14.7329 14.0443 14.4653 13.3951 14.4653 12.6343H7.325C7.325 13.3976 7.05233 14.0475 6.507 14.5838C5.96183 15.12 5.31383 15.3881 4.563 15.3881ZM4.56725 14.2918C5.02425 14.2918 5.41542 14.1321 5.74075 13.8126C6.06608 13.4931 6.22875 13.1019 6.22875 12.6391C6.22875 12.1762 6.0665 11.7851 5.742 11.4656C5.41767 11.1459 5.02892 10.9861 4.57575 10.9861C4.11292 10.9861 3.72175 11.1459 3.40225 11.4656C3.08275 11.7851 2.923 12.1762 2.923 12.6391C2.923 13.1019 3.08275 13.4931 3.40225 13.8126C3.72175 14.1321 4.11008 14.2918 4.56725 14.2918ZM1.51525 11.5381H2.04375C2.24592 11.0606 2.57575 10.6652 3.03325 10.3521C3.49058 10.0389 3.99767 9.88231 4.5545 9.88231C5.09867 9.88231 5.60058 10.0391 6.06025 10.3526C6.52008 10.6661 6.85958 11.0612 7.07875 11.5381H14.623V1.57281H1.823C1.74283 1.57281 1.6715 1.60481 1.609 1.66881C1.5465 1.73298 1.51525 1.80348 1.51525 1.88031V11.5381ZM17.2058 14.2918C17.6628 14.2918 18.0539 14.1321 18.3793 13.8126C18.7046 13.4931 18.8673 13.1019 18.8673 12.6391C18.8673 12.1762 18.705 11.7851 18.3805 11.4656C18.056 11.1459 17.6672 10.9861 17.2143 10.9861C16.7514 10.9861 16.3603 11.1459 16.0408 11.4656C15.7213 11.7851 15.5615 12.1762 15.5615 12.6391C15.5615 13.1019 15.7213 13.4931 16.0408 13.8126C16.3603 14.1321 16.7486 14.2918 17.2058 14.2918ZM15.719 9.44206H20.4865L17.4797 5.47656H15.719V9.44206Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
];
//Side Nav Bottom icons
const OrderSidenavBottomItems = [
  {
    id: 8,
    label: 'Store',
    moduleId: 2,
    path: FrontendRoutes.STORE_LOGO,
    icon: (
      <svg
        width="20"
        height="18"
        viewBox="0 0 20 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.5977 8.00434V15.8928C18.5977 16.3668 18.4318 16.7698 18.0999 17.1016C17.7679 17.4336 17.3649 17.5996 16.8909 17.5996H3.10744C2.63344 17.5996 2.23052 17.4336 1.89869 17.1016C1.56669 16.7698 1.40069 16.3668 1.40069 15.8928V7.98509C0.979522 7.68126 0.672605 7.25984 0.479939 6.72084C0.287438 6.18168 0.287938 5.61109 0.481438 5.00909L1.47244 1.76359C1.60461 1.35543 1.82877 1.02651 2.14494 0.776843C2.46111 0.527177 2.83886 0.402344 3.27819 0.402344H16.7032C17.1395 0.402344 17.5154 0.520843 17.8307 0.757843C18.1459 0.994676 18.373 1.32359 18.5122 1.74459L19.5169 5.00909C19.7106 5.61243 19.7111 6.18268 19.5184 6.71984C19.3258 7.25701 19.0189 7.68518 18.5977 8.00434ZM12.1677 7.32159C12.7282 7.32159 13.1446 7.15468 13.4169 6.82084C13.6894 6.48684 13.8007 6.12818 13.7507 5.74484L13.1507 1.80134H10.6987V5.73134C10.6987 6.15884 10.8429 6.53076 11.1312 6.84709C11.4195 7.16343 11.765 7.32159 12.1677 7.32159ZM7.72844 7.32159C8.19327 7.32159 8.57136 7.16343 8.86269 6.84709C9.15402 6.53076 9.29969 6.15884 9.29969 5.73134V1.80134H6.84769L6.25269 5.78334C6.20386 6.13001 6.31661 6.47309 6.59094 6.81259C6.86544 7.15193 7.24461 7.32159 7.72844 7.32159ZM3.34019 7.32159C3.72086 7.32159 4.04536 7.19009 4.31369 6.92709C4.58202 6.66409 4.74752 6.33501 4.81019 5.93984L5.41119 1.80134H3.22769C3.11869 1.80134 3.03127 1.82543 2.96544 1.87359C2.89977 1.92159 2.85252 1.99368 2.82369 2.08984L1.84969 5.32359C1.70419 5.79859 1.76769 6.25034 2.04019 6.67884C2.31252 7.10734 2.74586 7.32159 3.34019 7.32159ZM16.6584 7.32159C17.1994 7.32159 17.6236 7.11718 17.9309 6.70834C18.2383 6.29934 18.3109 5.83776 18.1487 5.32359L17.1497 2.07059C17.1177 1.97443 17.0689 1.90551 17.0032 1.86384C16.9374 1.82218 16.8516 1.80134 16.7459 1.80134H14.5919L15.1872 5.93984C15.2507 6.33101 15.4165 6.65909 15.6847 6.92409C15.953 7.18909 16.2776 7.32159 16.6584 7.32159ZM3.10744 16.2006H16.8909C16.9808 16.2006 17.0545 16.1718 17.1122 16.1141C17.1699 16.0563 17.1987 15.9825 17.1987 15.8928V8.63984C17.0949 8.67451 17.0005 8.69668 16.9157 8.70634C16.8307 8.71584 16.7449 8.72059 16.6582 8.72059C16.2134 8.72059 15.8221 8.63918 15.4844 8.47634C15.1466 8.31368 14.8235 8.05284 14.5152 7.69384C14.2452 8.00668 13.9199 8.25601 13.5392 8.44184C13.1585 8.62768 12.7242 8.72059 12.2362 8.72059C11.8164 8.72059 11.4233 8.63251 11.0569 8.45634C10.6906 8.28001 10.3414 8.02584 10.0094 7.69384C9.70044 8.02584 9.35044 8.28001 8.95944 8.45634C8.56827 8.63251 8.17844 8.72059 7.78994 8.72059C7.35294 8.72059 6.93694 8.64226 6.54194 8.48559C6.14711 8.32893 5.79969 8.06501 5.49969 7.69384C5.06886 8.12451 4.68011 8.40334 4.33344 8.53034C3.98661 8.65718 3.65561 8.72059 3.34044 8.72059C3.25244 8.72059 3.16244 8.71584 3.07044 8.70634C2.97844 8.69668 2.88819 8.67451 2.79969 8.63984V15.8928C2.79969 15.9825 2.82852 16.0563 2.88619 16.1141C2.94386 16.1718 3.01761 16.2006 3.10744 16.2006Z"
          fill="currentColor"
        />
        <path
          d="M9.71738 15.0918H10.9545L11.1401 14.164C11.2638 14.1124 11.3798 14.0583 11.488 14.0016C11.5962 13.9449 11.7071 13.8753 11.8205 13.7928L12.7174 14.0712L13.3359 13.0197L12.6246 12.4011C12.6452 12.2568 12.6555 12.1227 12.6555 11.999C12.6555 11.8753 12.6452 11.7413 12.6246 11.597L13.3359 10.9784L12.7174 9.92687L11.8205 10.2052C11.7071 10.1227 11.5962 10.0532 11.488 9.99646C11.3798 9.93976 11.2638 9.88563 11.1401 9.83408L10.9545 8.90625H9.71738L9.53181 9.83408C9.4081 9.88563 9.29212 9.93976 9.18388 9.99646C9.07563 10.0532 8.9648 10.1227 8.8514 10.2052L7.95449 9.92687L7.33594 10.9784L8.04728 11.597C8.02666 11.7413 8.01635 11.8753 8.01635 11.999C8.01635 12.1227 8.02666 12.2568 8.04728 12.4011L7.33594 13.0197L7.95449 14.0712L8.8514 13.7928C8.9648 13.8753 9.07563 13.9449 9.18388 14.0016C9.29212 14.0583 9.4081 14.1124 9.53181 14.164L9.71738 15.0918ZM10.3359 13.2361C9.99573 13.2361 9.70449 13.115 9.46223 12.8727C9.21996 12.6305 9.09882 12.3392 9.09882 11.999C9.09882 11.6588 9.21996 11.3676 9.46223 11.1253C9.70449 10.8831 9.99573 10.7619 10.3359 10.7619C10.6761 10.7619 10.9674 10.8831 11.2096 11.1253C11.4519 11.3676 11.5731 11.6588 11.5731 11.999C11.5731 12.3392 11.4519 12.6305 11.2096 12.8727C10.9674 13.115 10.6761 13.2361 10.3359 13.2361Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  {
    id: 9,
    label: 'Species - Products',
    moduleId: 2,
    path: FrontendRoutes.SPECIES,
    icon: (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 14H10L10.3 12.5C10.5 12.4167 10.6875 12.3292 10.8625 12.2375C11.0375 12.1458 11.2167 12.0333 11.4 11.9L12.85 12.35L13.85 10.65L12.7 9.65C12.7333 9.41667 12.75 9.2 12.75 9C12.75 8.8 12.7333 8.58333 12.7 8.35L13.85 7.35L12.85 5.65L11.4 6.1C11.2167 5.96667 11.0375 5.85417 10.8625 5.7625C10.6875 5.67083 10.5 5.58333 10.3 5.5L10 4H8L7.7 5.5C7.5 5.58333 7.3125 5.67083 7.1375 5.7625C6.9625 5.85417 6.78333 5.96667 6.6 6.1L5.15 5.65L4.15 7.35L5.3 8.35C5.26667 8.58333 5.25 8.8 5.25 9C5.25 9.2 5.26667 9.41667 5.3 9.65L4.15 10.65L5.15 12.35L6.6 11.9C6.78333 12.0333 6.9625 12.1458 7.1375 12.2375C7.3125 12.3292 7.5 12.4167 7.7 12.5L8 14ZM9 11C8.45 11 7.97917 10.8042 7.5875 10.4125C7.19583 10.0208 7 9.55 7 9C7 8.45 7.19583 7.97917 7.5875 7.5875C7.97917 7.19583 8.45 7 9 7C9.55 7 10.0208 7.19583 10.4125 7.5875C10.8042 7.97917 11 8.45 11 9C11 9.55 10.8042 10.0208 10.4125 10.4125C10.0208 10.8042 9.55 11 9 11ZM2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H16C16.55 0 17.0208 0.195833 17.4125 0.5875C17.8042 0.979167 18 1.45 18 2V16C18 16.55 17.8042 17.0208 17.4125 17.4125C17.0208 17.8042 16.55 18 16 18H2ZM2 16H16V2H2V9V16Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  {
    id: 10,
    label: 'Settings',
    moduleId: 2,
    path: '/app-settings',
    icon: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.80337 19.3116L7.42262 16.3266C7.14629 16.2364 6.85737 16.1085 6.55587 15.9428C6.25421 15.7771 5.99204 15.602 5.76937 15.4173L3.02262 16.5693L0.815872 12.7308L3.21587 10.9193C3.18971 10.7761 3.17254 10.6336 3.16437 10.4918C3.15637 10.35 3.15237 10.1937 3.15237 10.0231C3.15237 9.89423 3.15846 9.75306 3.17062 9.59956C3.18296 9.44606 3.20062 9.26865 3.22362 9.06731L0.815872 7.27131L3.02262 3.47231L5.79387 4.63481C6.02137 4.44698 6.27329 4.27306 6.54962 4.11306C6.82579 3.95323 7.11362 3.81848 7.41312 3.70881L7.80337 0.695312H12.1966L12.5774 3.69056C12.8877 3.80456 13.1664 3.93648 13.4134 4.08631C13.6605 4.23598 13.9079 4.41881 14.1554 4.63481L16.9774 3.47231L19.1841 7.27131L16.6851 9.13756C16.7178 9.2984 16.7365 9.44356 16.7414 9.57306C16.7462 9.70256 16.7486 9.84856 16.7486 10.0111C16.7486 10.1672 16.7454 10.3133 16.7389 10.4493C16.7325 10.5853 16.712 10.7413 16.6774 10.9173L19.1371 12.7308L16.9304 16.5693L14.1554 15.3876C13.9265 15.5799 13.6887 15.7495 13.4419 15.8963C13.195 16.043 12.9069 16.183 12.5774 16.3163L12.1966 19.3116H7.80337ZM9.00387 17.9126H10.9439L11.3171 15.2213C11.8125 15.088 12.2612 14.904 12.6634 14.6693C13.0657 14.4346 13.4589 14.1244 13.8429 13.7386L16.3399 14.8031L17.3121 13.1256L15.1226 11.4886C15.1976 11.2296 15.251 10.9796 15.2826 10.7388C15.3145 10.4978 15.3304 10.2552 15.3304 10.0111C15.3304 9.75756 15.3165 9.51773 15.2889 9.29156C15.2614 9.06523 15.206 8.82065 15.1226 8.55781L17.3314 6.88381L16.3794 5.20406L13.8256 6.28381C13.523 5.95298 13.138 5.6504 12.6706 5.37606C12.2033 5.10173 11.7482 4.91006 11.3054 4.80106L10.9911 2.09431H9.01312L8.69462 4.78406C8.16779 4.91273 7.70521 5.08923 7.30687 5.31356C6.90837 5.5379 6.50371 5.85298 6.09287 6.25881L3.62062 5.20406L2.64387 6.88381L4.79562 8.48081C4.71229 8.73148 4.65396 8.9819 4.62062 9.23206C4.58729 9.48223 4.57062 9.74148 4.57062 10.0098C4.57062 10.2603 4.58521 10.5064 4.61437 10.7481C4.64354 10.9897 4.69662 11.2433 4.77362 11.5088L2.64387 13.1231L3.62062 14.8031L6.07562 13.7531C6.47362 14.1511 6.88062 14.4677 7.29662 14.7031C7.71262 14.9382 8.17471 15.1183 8.68287 15.2433L9.00387 17.9126ZM9.96462 12.9126C10.7675 12.9126 11.4507 12.6303 12.0144 12.0658C12.5782 11.5015 12.8601 10.8171 12.8601 10.0126C12.8601 9.20806 12.578 8.52398 12.0136 7.96031C11.4495 7.39648 10.7653 7.11456 9.96112 7.11456C9.15079 7.11456 8.46504 7.39681 7.90387 7.96131C7.34271 8.52564 7.06212 9.21006 7.06212 10.0146C7.06212 10.8191 7.34271 11.5031 7.90387 12.0668C8.46504 12.6306 9.15196 12.9126 9.96462 12.9126Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
];

export const SideNav: React.FC<OrderSideNavProps> = ({ active }) => {
  const [activeId, setActiveId] = useState<number>();
  const navigate = useNavigate();

  // Display the icons which user modules have
  const modules: number[] = JSON.parse(localStorage.getItem('modules') || '[]');
  // Get the top nav icons (except the settings)
  const topSideNavIcons = OrderSidenavItems.filter(
    ({ moduleId }) => moduleId !== CustomerModules.SETTINGS,
  );
  const sideNavIcons = topSideNavIcons.filter((icon) =>
    modules.includes(icon.moduleId),
  );
  // Get the settings icon
  const settingsIcon = OrderSidenavBottomItems.find(
    ({ moduleId }) => moduleId === CustomerModules.SETTINGS,
  );
  // Show My store settings icons only if user has module 2(setting)
  const showSettingsIcon =
    settingsIcon && modules.includes(CustomerModules.SETTINGS);

  useEffect(() => {
    setActiveId(active);
  }, [active]);

  /**
   * Handles navigation clicks for both main and bottom navigation items.
   *
   * This function updates the active navigation ID and optionally navigates
   * to a specified route. For bottom navigation items, it adds a special
   * state flag (`fromSettings: true`) to the navigation state.
   *
   * @param {number} id - The ID of the navigation item being clicked. Updates the activeId state.
   * @param {string} [path] - Optional. The route path to navigate to. If omitted, only the active ID is updated.
   * @param {boolean} [forBottomNav=false] - Optional. Indicates whether the click is from the bottom navigation.
   *                                        If true, adds `{ fromSettings: true }` to the navigation state.
   */
  const handleNavClick = (id: number, path?: string, forBottomNav = false) => {
    setActiveId(id);

    if (path) {
      navigate(path, {
        state: forBottomNav ? { fromSettings: true } : undefined,
      });
    }
  };

  return (
    <aside className="w-16 lg:w-56 shadow-md p-4 flex flex-col justify-between bg-primary">
      <div>
        {/* Logo */}
        <div className="mb-4">
          <div className="flex items-center justify-center lg:justify-start">
            {/* --- Icon logo (mobile + iPad portrait) --- */}
            <img
              src={Assets.LOGO_ICON}
              alt="Sidebar icon"
              className="w-14 h-14 object-contain rounded-xl lg:hidden"
            />
            {/* --- Full logo (landscape + desktop) --- */}
            <img
              src={Assets.LOGO_WITH_TEXT}
              alt="Full logo"
              className="hidden lg:block h-12 object-contain"
            />
          </div>
        </div>

        {/* Navigation icons */}
        <ul className="space-y-4 flex flex-col items-stretch">
          {sideNavIcons.map(({ id, icon, label, path }) => {
            const isActive = id === activeId;
            return (
              <li key={id}>
                <button
                  type="button"
                  onClick={() => handleNavClick(id, path)}
                  className={`
    w-full cursor-pointer rounded-md p-2
    transition-colors duration-300
    flex items-center justify-center md:justify-start gap-3
    ${isActive
                      ? 'bg-white text-black'
                      : 'text-white hover:text-black hover:bg-white'
                    }
  `}
                  title={label}
                  aria-label={label}
                >
                  {icon}

                  <span className="hidden lg:inline text-sm font-medium">
                    {label}
                  </span>
                </button>
              </li>
            );
          })}
        </ul>
      </div>

      {/* Settings icon */}
      {showSettingsIcon && OrderSidenavBottomItems.length > 0 && (
        <ul className="space-y-4 flex flex-col items-stretch">
          {OrderSidenavBottomItems.map(({ id, icon, label, path }) => {
            const isActive = id === activeId;

            return (
              <li key={id}>
                <button
                  type="button"
                  onClick={() => handleNavClick(id, path, true)}
                  className={`
            w-full cursor-pointer rounded-md p-2
            transition-all duration-300
            flex items-center justify-start gap-3
            ${isActive
                      ? 'bg-white text-black'
                      : 'text-white hover:bg-white hover:text-black'
                    }
          `}
                  title={label}
                  aria-label={label}
                >
                  {icon}

                  <span className="hidden lg:inline text-sm font-medium">
                    {label}
                  </span>
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </aside>
  );
};
